const BannerStatus = {
  PREPARE: 1,
  PUBLIC: 2,
  CLOSE: 3
}
export default BannerStatus
